const initialState = {
  javaServerStatus: "critical",
  cameraData: [],
  cameraStatus: "critical",
  eccStatus: "critical",
  pushButtonsStatus: "critical",
  detailedViewData: [],
  loading: false,
  loadingCamera: false,
  loadingJava: false,
  loadingEcc: false,
  loadingPushButtons: false,
  error: null,
  data:null,
};

const HealthStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case "JAVA_DATA_REQUEST":
      return { ...state, loadingJava: true };
    case "JAVA_DATA_SUCCESS":
      return { ...state, javaServerStatus: action.payload, loadingJava: !1 };
    case "JAVA_DATA_FAILURE":
      return { ...state, javaServerStatus: action.payload, loadingJava: !1 };
    case "FETCH_CAMERA_REQUEST":
      return { ...state, loadingCamera: !0 };
    case "FETCH_CAMERA_SUCCESS":
      return {
        ...state,
        cameraData: action.payload,
        loadingCamera: !1,
        error: null,
      };
    case "FETCH_CAMERA_FAIL":
      return {
        ...state,
        cameraData: [],
        loadingCamera: !1,
        error: "Failed to fetch camera data",
      };
    case "SET_CAMERA_STATUS":
      return { ...state, cameraStatus: action.payload };
    case "FETCH_ECC_REQUEST":
      return { ...state, loadingEcc: !0 };
    case "FETCH_ECC_SUCCESS":
      return {
        ...state,
        eccStatus: action.payload,
        loadingEcc: !1,
        error: null,
      };
    case "FETCH_ECC_FAILURE":
      return {
        ...state,
        eccStatus: action.payload,
        loadingEcc: !1,
        error: "Failed to fetch ECC status",
      };
    case "FETCH_PUSH_BUTTONS_REQUEST":
      return { ...state, loadingPushButtons: !0 };
    case "FETCH_PUSH_BUTTONS_SUCCESS":
      return {
        ...state,
        pushButtonsStatus: action.payload,
        loadingPushButtons: !1,
        error: null,
      };
    case "FETCH_PUSH_BUTTONS_FAILURE":
      return {
        ...state,
        pushButtonsStatus: action.payload,
        loadingPushButtons: !1,
        error: "Failed to fetch Push Buttons status",
      };
    case "FETCH_DETAILED_VIEW_REQUEST":
      return { ...state, loading: !0, error: null };
    case "FETCH_DETAILED_VIEW_SUCCESS":
      return { ...state, loading: !1, detailedViewData: action.payload };
    case "FETCH_DETAILED_VIEW_FAILURE":
      return { ...state, loading: !1, error: action.payload };
    case "SET_DETAILED_VIEW_DATA":
      return {
        ...state,
        detailedViewData: action.payload,
        loadingDetailedView: !1,
      };
    case "CLEAR_DETAILED_VIEW":
      return { ...state, detailedViewData: [] };
    case "HEALTH_STATUS_DATA_REQUEST":
      return { ...state, loading: true };
    case "HEALTH_STATUS_DATA_SUCCESS":
      return { ...state, data: action.payload, loading: !1 };
    case "HEALTH_STATUS_DATA_FAILURE":
      return { ...state, data: action.payload, loading: !1 };
    default:
      return state;
  }
};

export default HealthStatusReducer;
